import React, { FunctionComponent } from 'react'

import { AURORA_CDN_ASSETS_LINK_BASE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

interface ClipboardSpotIllustrationProps {
  size?: number
}

export const ClipboardSpotIllustration: FunctionComponent<ClipboardSpotIllustrationProps> = ({ size = 125 }) => {
  return (
    <Image
      testID={tID('ClipboardSpotIllustration')}
      source={{ uri: `${AURORA_CDN_ASSETS_LINK_BASE}/clipboardSpotIllustration.png` }}
      style={{ width: size, height: size }}
      contentFit='contain'
      accessibilityIgnoresInvertColors
    />
  )
}
